<template>
  <b-modal id="modal-impressao-termo"
           ref="modal-impressao-termo"
           class="impressao--modal"
           :content-class="zoomClass"
           size="xl">
    <div class="col body">
      <div class="pagina-modal">
        <div id="paste-html"
             class="pagina-margin-modal"
             v-html="html" />
      </div>
    </div>

    <template v-slot:modal-header>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            class="ml-2"
            variant="primary"
            :disabled="zoomLocal < 1"
            @click="zoomLocal--">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomMinus" />
          </b-button>

          <b-button
            size="sm"
            class="ml-2"
            variant="primary"
            :disabled="zoomLocal > 1"
            @click="zoomLocal++">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomPlus" />
          </b-button>

          <b-button
            size="sm"
            class="ml-2"
            variant="default"
            @click="$bvModal.hide('modal-impressao-termo')">
            <icon-svg class="impressao_documento--icon icon--xs"
                      icon="close" />
          </b-button>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            class="mr-1"
            variant="default"
            @click="$bvModal.hide('modal-impressao-termo')">
            Voltar
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            class="ml-1"
            @click="imprimir()">
            Imprimir
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
  export default {
    name: "ModalTermo",
    props: ["html", "zoom"],
    data () {
      return {
        zoomLocal: 0
      }
    },
    computed: {
      zoomClass: function () {
        let className = ''

        switch (this.zoomLocal) {
        case 2:
          className = 'modalZoom--2'
          break
        case 1:
          className = 'modalZoom--1'
          break
        case 0:
          className = ''
          break
        }

        return className
      }
    },
    watch: {
      zoom: function () {
        this.zoomLocal = this.zoom
      }
    },
    mounted () {
      this.zona_secao = this.zoom
    },
    methods: {
      imprimir () {
        this.$emit('onImprimir', this.html)
      }
    }
  }
</script>

<style lang="scss">
@import "@/scss/_utilities/_exports.scss";
@import "@/scss/_components/_termos.scss";
@import "@/scss/_components/_modals.scss";
</style>
